module.exports = "query {\n    merlinAppSubscriptionPlans {\n        id\n        price\n        level\n        date_modifier\n    }\n}\n"